import './../../styles/templates/wishlist.scss';

const P_KEYS = {
  NAME: 'dt',
  VENDOR: 'bt',
  URL: 'du',
  IMAGE: 'iu',
  PRICE: 'pr',
  COMPARE_AT_PRICE: 'op',
  VARIANT_ID: 'epi',
};

const fillNodesWith = (nodeOrNodeList, content) => {
  if (nodeOrNodeList) {
    // Nodelist
    if (nodeOrNodeList.length) {
      const nodes = Array.from(nodeOrNodeList);

      nodes.map((node) => {
        node.innerHTML = content;
      });
    } else {
      nodeOrNodeList.innerHTML = content;
    }
  }
};

const changeNodeAttribute = (nodeOrNodeList, attributeName, attributeValue) => {
  if (nodeOrNodeList) {
    // Nodelist
    if (nodeOrNodeList.length) {
      const nodes = Array.from(nodeOrNodeList);
      nodes.map((node) => {
        node.setAttribute(attributeName, attributeValue);
      });
    } else {
      nodeOrNodeList.setAttribute(attributeName, attributeValue);
    }
  }
};

const addClass = (nodeOrNodeList, className) => {
  if (nodeOrNodeList) {
    // Nodelist
    if (nodeOrNodeList.length) {
      const nodes = Array.from(nodeOrNodeList);
      nodes.map((node) => {
        node.classList.add(className);
      });
    } else {
      // Node
      nodeOrNodeList.classList.add(className);
    }
  }
};

const removeClass = (nodeOrNodeList, className) => {
  if (nodeOrNodeList) {
    // Nodelist
    if (nodeOrNodeList.length) {
      const nodes = Array.from(nodeOrNodeList);
      nodes.map((node) => {
        node.classList.remove(className);
      });
    } else {
      // Node
      nodeOrNodeList.classList.remove(className);
    }
  }
};

const attachListener = (nodeOrNodeList, event, callback) => {
  if (nodeOrNodeList && typeof callback === 'function') {
    // Nodelist
    if (nodeOrNodeList.length) {
      const nodes = Array.from(nodeOrNodeList);
      nodes.map((node) => node.addEventListener(event, callback));
    } else {
      // Node
      nodeOrNodeList.addEventListener(event, callback);
    }
  }
};

const triggerEvent = (el, evName) => {
  const event = new CustomEvent(evName);
  el.dispatchEvent(event);
};

(function (window, $) {
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }

  const wishlistRender = function (products) {
    (function ($) {
      var template = document.querySelector('[data-wishlist-template]');
      var empty_template = document.querySelector('[data-wishlist-empty]');
      var wishlistContainer = document.getElementById('wishlist-content');

      var startLoading = function (context) {
        if (context) {
          context.classList.add('loading');
        } else {
          wishlistContainer.classList.add('loading');
        }
      };

      var stopLoading = function (context) {
        if (context) {
          context.classList.remove('loading');
        } else {
          wishlistContainer.classList.remove('loading');
        }
      };

      if (!products || products.length < 1) {
        empty_template.style.display = 'block';
        return;
      }

      products.forEach(function (p) {
        var row = template.cloneNode(true);
        const CURRENCY = _swat.currency;

        row.classList.remove('hidden');
        fillNodesWith(row.querySelectorAll('[data-name]'), p[P_KEYS.NAME]);
        const vendorTemplateSlots = row.querySelectorAll(
          '[data-vendor-wrapper]',
        );
        if (
          p[P_KEYS.VENDOR] &&
          vendorTemplateSlots &&
          vendorTemplateSlots.length
        ) {
          fillNodesWith(
            row.querySelectorAll('[data-vendor-wrapper]'),
            p[P_KEYS.VENDOR],
          );
        } else {
          if (vendorTemplateSlots && vendorTemplateSlots.length) {
            addClass(vendorTemplateSlots, 'visually-hidden');
          }
        }

        changeNodeAttribute(
          row.querySelectorAll('[data-url]'),
          'href',
          p[P_KEYS.URL],
        );
        changeNodeAttribute(
          row.querySelectorAll('[data-image]'),
          'src',
          p[P_KEYS.IMAGE],
        );

        // if (!p.stk) {
        //   row.find('[data-add]').addClass('disabled');
        // }

        attachListener(
          row.querySelectorAll('[data-remove]'),
          'click',
          function (e) {
            e.preventDefault();
            // Start Loader
            startLoading(row);

            _swat.removeFromWishList(p, function callback() {
              row.remove();
              window.loadWishlistBubble(0);
              // Stop Loader
              stopLoading(row);
            });
          },
        );
        wishlistContainer.append(row);
      });
    })(jQuery);
  };

  window.SwymCallbacks.push(function () {
    _swat.fetchWrtEventTypeET(function (products) {
      wishlistRender(products);
    }, _swat.EventTypes.addToWishlist);
  });
})(window, jQuery);
